import React, { useMemo } from "react";

import { copy } from "shared/assets";
import { Modal } from "shared/components";
import { IAPIState, IFormButtons } from "shared/types";
import { IStageCapacity } from "Venues/types";
import { StageCapacityForm } from "../components/StageCapacityForm";

const editCopy = copy.createStage.capacities.edit;

interface EditCapacityModalProps {
  capacity?: IStageCapacity;
  apiMeta?: { status: IAPIState; error?: any };
  handleEdit: (capacity: IStageCapacity, id?: string) => void;
  handleClose: () => void;
}

export const EditCapacityModal: React.FC<EditCapacityModalProps> = ({
  capacity,
  handleClose,
  handleEdit,
  apiMeta,
  ...rest
}) => {
  const onSubmit = (newCapacity: IStageCapacity) => {
    handleEdit(newCapacity, capacity?.id);
  };

  const buttons: IFormButtons = useMemo(
    () => ({
      secondary: {
        onClick: handleClose,
      },
    }),
    [handleClose]
  );

  return (
    <Modal
      title={editCopy.title}
      handleClose={handleClose}
      data-testid="edit_capacity_modal"
    >
      <StageCapacityForm
        handleSubmit={onSubmit}
        buttons={buttons}
        defaultValues={{ capacity }}
        submitMode="isDirty"
        isSubmitting={apiMeta?.status === IAPIState.pending}
        hasError={!!apiMeta?.error}
        {...rest}
      />
    </Modal>
  );
};
